import { updates } from '../updates';

export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.updates = updates;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/whats-new/whats-new-sidemenu/whats-new-sidemenu.controller.js